import type { CreatorDealBrief } from '../api/payment/brand-deal.api';

// Lời mời thẳng creator làm brief (spec 2026-10-12 §7). Câu khớp BrandBriefInviteConst phía payment.

export const BRIEF_TEXT_MIN_LENGTH = 20;
export const BRIEF_TEXT_MAX_LENGTH = 3000;
export const BRIEF_TEXT_INVALID_MESSAGE = 'Mô tả brief từ 20 đến 3.000 ký tự.';
export const BRIEF_UNCHANGED_MESSAGE = 'Brief chưa có thay đổi nào.';
export const BRIEF_INVITE_FORM_NOTE =
  'Creator nhận brief hiện tại của chiến dịch. Trước khi creator nhận, bạn sửa được brief riêng cho lời mời này, mỗi lần sửa creator có thêm ít nhất 24 giờ để trả lời.';
export const BRIEF_EDIT_PRICE_NOTE = 'Giá đã giữ lúc mời nên không đổi được. Huỷ lời mời thì không mời lại creator này trong chiến dịch được nữa.';
export const BRIEF_INVITE_ASK_NOTE =
  'Chưa rõ brief thì hỏi người đặt ở phần Trao đổi trước khi nhận. Chỉ bản brief người đặt lưu mới là brief chính thức.';
export const BRIEF_INVITE_PENDING_NOTE =
  'Bạn chưa nhận lời mời này. Đọc brief, hỏi người đặt ở phần Trao đổi nếu cần, rồi trả lời ở mục Lời mời từ doanh nghiệp.';

/** Cùng luật máy chủ: 20–3.000 ký tự sau khi cắt khoảng trắng, và phải khác bản hiện tại (nếu truyền). */
export const validateBriefText = (text: string, current?: string | null): string | null => {
  const t = (text ?? '').trim();
  if (t.length < BRIEF_TEXT_MIN_LENGTH || t.length > BRIEF_TEXT_MAX_LENGTH) return BRIEF_TEXT_INVALID_MESSAGE;
  if (current != null && t === current.trim()) return BRIEF_UNCHANGED_MESSAGE;
  return null;
};

/** Bản 1 là brief của chiến dịch lúc mời nên không cần nhãn. */
export const briefVersionLabel = (version?: number | null): string | null =>
  version && version > 1 ? `Brief bản ${version}` : null;

export const acceptBriefConfirmText = (brief: Pick<CreatorDealBrief, 'submitDays'>): string =>
  `Nhận làm brief này? Bạn có ${brief.submitDays} ngày để nộp bài kể từ bây giờ.`;

export const submitWindowLabel = (days: number): string => `Nộp bài trong ${days} ngày kể từ lúc nhận`;

export const briefInviteConfirmText = (holdNoteText: string, creatorName: string): string =>
  `${holdNoteText} để mời ${creatorName} làm brief. Tiếp tục?`;
